import { SuggestedCategory } from '../SuggestedCategory';

type ClassificationResult =
  | [string, number, number, number]
  | [string, number, number]
  | [string, number]
  | undefined;

type ProcessingWithClassification = {
  classification?: { result?: ClassificationResult[] | null } | null;
} | null | undefined;

interface SuggestedCategoryProps {
  category: string | null | undefined;
  processing: ProcessingWithClassification;
}

interface ClassificationBadgeProps {
  classification: string;
  certainty: number;
  /** User-overridden category; rendered as an arrow line when it differs from the classification. */
  overrideCategory?: string | null;
}

function ClassificationBadge({ classification, certainty, overrideCategory }: ClassificationBadgeProps) {
  const override = overrideCategory?.trim();
  const effectiveOverride = override && override !== classification ? override : null;
  return (
    <div className="min-w-0">
      <span
        className="inline-block max-w-full truncate align-bottom px-2 py-0.5 rounded bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200 text-xs"
        title={classification}
      >
        {classification}
      </span>
      <div className="text-xs text-gray-500 dark:text-zinc-500 mt-1">{Math.round(certainty * 100)}%</div>
      {effectiveOverride && (
        <div className="text-xs text-amber-700 dark:text-amber-400 mt-1">→ {effectiveOverride}</div>
      )}
    </div>
  );
}

export function ClassificationCell(props: SuggestedCategoryProps | ClassificationBadgeProps) {
  if ('classification' in props) {
    return <ClassificationBadge {...props} />;
  }
  return (
    <SuggestedCategory
      documentCategory={props.category}
      suggestedCategory={props.processing?.classification?.result?.[0]}
    />
  );
}
